import React from 'react';
import Header from '../components/Header';
import SEO from '../components/SEO';
import './Team.css';

const Team = () => {
  return (
    <div className="page-container">
      <SEO page="team" />
      <Header />
      <main className="main-content full-width">
        <section className="team-section">
          <h2>我们的团队</h2>
          <div className="team-grid">
            <div className="member-card">
              <img 
                src="/images/team1.jpg" 
                alt="团队成员" 
                width="200"
                height="200"
                loading="lazy"
              />
              <h3>张三</h3>
              <p>馆长</p>
            </div>
            <div className="member-card">
              <img 
                src="/images/team2.jpg" 
                alt="团队成员"
                width="200"
                height="200"
                loading="lazy"
              />
              <h3>李四</h3>
              <p>活动策划</p>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default Team;
